import { FC, CSSProperties } from 'react';
import { useTheme } from '@material-ui/core';
import { WbInfoTooltip } from '../../WbInfoTooltip';
import { IconLabelBox } from '../../IconLabelBox';
import { KoFilledIcon, KoIcon } from './Icons';
import { useStyles } from './style';

interface Props {
  filled?: boolean;
  variant?: 'reduced' | 'default';
  style?: CSSProperties;
}

export const FailedIcon: FC<Props> = ({
  filled,
  style,
  variant = 'default',
}) => {
  const theme = useTheme();
  const classes = useStyles();
  return (
    <WbInfoTooltip
      title="Failed. You need to solve the errors reported since they will prevent the deployment"
      icon={
        <span>
          {/* eslint-disable-next-line no-nested-ternary */}
          {variant === 'reduced' ? (
            filled ? (
              <KoFilledIcon
                htmlColor={theme.palette.error.main}
                className={classes.icon}
                style={style}
              />
            ) : (
              <KoIcon
                htmlColor={theme.palette.error.main}
                className={classes.icon}
                style={style}
              />
            )
          ) : (
            <IconLabelBox
              label="Failure"
              backgroundColor={theme.palette.error.main}
              value="KO"
            />
          )}
        </span>
      }
    />
  );
};
